'use memo'

import { REGISTRATION_TEAM_PARAM } from '@sportninja/common/features/registration/registrationUrlParams'
import {
  findPreselectableTeam,
  type PreselectableTeam,
} from '../utils/preselectTeam'
import { usePreselectFromUrl } from './usePreselectFromUrl'

interface Params<T extends PreselectableTeam> {
  /** Teams offered for the division the reader picked. Null while loading. */
  teams: T[] | null | undefined
  /**
   * The current selection — a pre-select only ever fills an empty selector.
   *
   * Read only for WHETHER something is held, so any shape will do: the held
   * team need not be one of `teams`, and may not share their type (the context
   * can hold a player's team from the registration payload).
   */
  selectedTeam: object | null
  /** The section is in "create a new team" mode; leave the reader's mode alone. */
  isAddingNewTeam: boolean
  onSelect: (team: T) => void
}

/** Pre-select the team a link points at (`?team_id=`). */
export const usePreselectedTeam = <T extends PreselectableTeam>({
  teams,
  selectedTeam,
  isAddingNewTeam,
  onSelect,
}: Params<T>): void => {
  usePreselectFromUrl<T>({
    param: REGISTRATION_TEAM_PARAM,
    enabled: Boolean(teams?.length) && !selectedTeam && !isAddingNewTeam,
    resolve: (teamId) => findPreselectableTeam(teams, teamId),
    onSelect,
  })
}
